/*
  MICROSOFT-LINKS IN DER SPRACHE DER SEITE

  Warum es diese Datei gibt
  -------------------------
  `sections/ol-anleitung.liquid` baut die Adressen zu Microsoft selbst
  zusammen und uebersetzt dafuer den Sprachcode in zwei Tabellen:
  microsoft.com will `it-it` klein, support.microsoft.com will `it-IT`
  mit grossem Land. Diese Tabellen kennen it, es, fr, tr und en; alles
  andere landet im `else`-Zweig und damit auf `de-de` bzw. `de-DE`.

  Seit der Shop auch Polnisch und Daenisch spricht, schickt dieser
  `else`-Zweig polnische und daenische Besucher auf deutsche
  Microsoft-Seiten. Die Tabelle gehoert in die Sektion - nur ist die
  Datei 39 KB gross und laesst sich mit dem Werkzeug, mit dem dieses
  Theme gepflegt wird, nicht mehr am Stueck schreiben (dieselbe Lage
  wie bei bsfa-vergleich.liquid und styles.css, siehe
  snippets/ol-nacht-start.liquid).

  Deshalb korrigiert dieses Skript die fertigen Adressen im Browser.
  Das ist ein Nachbessern, kein Ersatz: wird die Sektion einmal
  bearbeitbar, gehoeren pl und da in das `case` dort - dann kann diese
  Datei weg.

  Was es tut
  ----------
  Nur wenn die Seitensprache in der Tabelle unten steht (pl, da),
  werden ausschliesslich Verweise auf microsoft.com getauscht, und
  auch dort ausschliesslich das Sprachsegment `de-de` / `de-DE`
  direkt hinter dem Gastgebernamen. Alles andere bleibt unberuehrt:
  keine Downloadadressen, keine fremden Ziele, kein Text.

  Faellt das Skript aus, bleiben die deutschen Microsoft-Seiten
  stehen - unschoen, aber nicht kaputt.
*/
(function () {
  'use strict';

  var TABELLE = {
    pl: { klein: 'pl-pl', gross: 'pl-PL' },
    da: { klein: 'da-dk', gross: 'da-DK' }
  };

  function sprache() {
    var l = document.documentElement.getAttribute('lang') || '';
    return l.slice(0, 2).toLowerCase();
  }

  function tauschen(adresse, ziel) {
    // Nur Microsoft, nur das Sprachsegment ganz vorn im Pfad.
    return adresse
      .replace(
        /^(https?:\/\/(?:www\.)?microsoft\.com)\/de-de(?=\/|$)/i,
        '$1/' + ziel.klein
      )
      .replace(
        /^(https?:\/\/support\.microsoft\.com)\/de-DE(?=\/|$)/,
        '$1/' + ziel.gross
      );
  }

  function lauf() {
    var ziel = TABELLE[sprache()];
    if (!ziel) return;

    var verweise = document.querySelectorAll(
      'a[href*="microsoft.com/de-de"], a[href*="microsoft.com/de-DE"]'
    );
    for (var i = 0; i < verweise.length; i++) {
      var a = verweise[i];
      var alt = a.getAttribute('href') || '';
      var neu = tauschen(alt, ziel);
      if (neu !== alt) a.setAttribute('href', neu);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lauf, { once: true });
  } else {
    lauf();
  }
})();
